import { Input } from "@/components/ui/input";
import { ReadProjectStorePeriod } from "@/types/projectStorePeriod";
import { Row } from "@tanstack/react-table";
import { memo, useCallback } from "react";
import { useProjectStoreFormStore } from "../hooks/useProjectStoreFormStore";
import { selectClientStoreNumber } from "../stores/projectStoreFormStore";

interface ClientStoreNumberFieldProps {
  row: Row<ReadProjectStorePeriod>;
  disabled?: boolean;
}

const ClientStoreNumberField = memo(
  ({ row, disabled }: ClientStoreNumberFieldProps) => {
    const storeId = row.original.id;
    const isSubmitting = useProjectStoreFormStore((s) => s.isSubmitting);
    const value = useProjectStoreFormStore(
      useCallback((s) => selectClientStoreNumber(s, storeId), [storeId]),
    );
    const setClientStoreNumber = useProjectStoreFormStore(
      (s) => s.setClientStoreNumber,
    );

    const onChange = useCallback(
      (event: React.ChangeEvent<HTMLInputElement>) => {
        setClientStoreNumber(storeId, event.target.value);
      },
      [setClientStoreNumber, storeId],
    );

    return (
      <div className="flex items-center justify-center h-full py-[2px] px-2">
        <Input
          value={value}
          onChange={onChange}
          disabled={isSubmitting || disabled}
          className="h-full rounded-sm focus-visible:ring-offset-0"
        />
      </div>
    );
  },
);

ClientStoreNumberField.displayName = "ClientStoreNumberField";

export default ClientStoreNumberField;
